/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SignalRuleCount } from "./SignalRuleCount";
import {
  SignalRuleCountFromJSON,
  SignalRuleCountFromJSONTyped,
  SignalRuleCountToJSON,
  SignalRuleCountToJSONTyped,
} from "./SignalRuleCount";
import type { SignalAlarmRules } from "./SignalAlarmRules";
import {
  SignalAlarmRulesFromJSON,
  SignalAlarmRulesFromJSONTyped,
  SignalAlarmRulesToJSON,
  SignalAlarmRulesToJSONTyped,
} from "./SignalAlarmRules";

/**
 *
 * @export
 * @interface AlarmRulesResponse
 */
export interface AlarmRulesResponse {
  /**
   *
   * @type {Array<SignalAlarmRules>}
   * @memberof AlarmRulesResponse
   */
  rules: Array<SignalAlarmRules>;
  /**
   *
   * @type {Array<SignalRuleCount>}
   * @memberof AlarmRulesResponse
   */
  signalRuleCounts: Array<SignalRuleCount>;
}

/**
 * Check if a given object implements the AlarmRulesResponse interface.
 */
export function instanceOfAlarmRulesResponse(
  value: object,
): value is AlarmRulesResponse {
  if (!("rules" in value) || value["rules"] === undefined) return false;
  if (!("signalRuleCounts" in value) || value["signalRuleCounts"] === undefined)
    return false;
  return true;
}

export function AlarmRulesResponseFromJSON(json: any): AlarmRulesResponse {
  return AlarmRulesResponseFromJSONTyped(json, false);
}

export function AlarmRulesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AlarmRulesResponse {
  if (json == null) {
    return json;
  }
  return {
    rules: (json["rules"] as Array<any>).map(SignalAlarmRulesFromJSON),
    signalRuleCounts: (json["signalRuleCounts"] as Array<any>).map(
      SignalRuleCountFromJSON,
    ),
  };
}

export function AlarmRulesResponseToJSON(json: any): AlarmRulesResponse {
  return AlarmRulesResponseToJSONTyped(json, false);
}

export function AlarmRulesResponseToJSONTyped(
  value?: AlarmRulesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rules: (value["rules"] as Array<any>).map(SignalAlarmRulesToJSON),
    signalRuleCounts: (value["signalRuleCounts"] as Array<any>).map(
      SignalRuleCountToJSON,
    ),
  };
}
